import React, { useRef, useState } from "react";

import "./style.css";
import {
  Box,
  Typography,
  Icon,
} from "@anchor/react-components/dist/lib/components";
import { McTooltip, McIcon } from "@maersk-global/mds-react-wrapper/components-core";
import { AiSuggestionsInline } from "../Report/RcaQualityPanel";

import { Group } from "@anchor/react-components/dist/lib/components/Radio";
import PTask from "./PTask";
import Jira from "./Jira";
import Comments from "../Comments/Comments";
import Collaborators from "../Collaborators/Collaborators";
import { Col, Row } from "react-bootstrap";
import PhotoUploadModal from "../PhotoUploadModal/PhotoUploadModal";
import UserInfo from "../../context/UserAccessContext";

function PreventiveAndCorrectiveMeasures(props) {
  const { userIsAdmin } = UserInfo();

  const divRef = useRef();

  const [photoModal, setPhotoModal] = useState(false);
  const [aiOpen, setAiOpen] = useState(false);

  const handlePhotoModalClick = () => {
    setPhotoModal(!photoModal);
  };
  const [showRecommnedations, setShowRecommnedations] = useState(false);

  const [radioOption, setRadioOption] = useState("Jira");
  const handleRadioChange = (event) => {
    setRadioOption(event.target.value);
    props.dispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "PreventiveAndCorrectiveMeasuresState",
      payload: {
        ...props.PreventiveAndCorrectiveMeasuresState,
        trackingMethod: event.target.value,
      },
    });
  };

  const handlePhotoModalClose = () => {
    setPhotoModal(false);
    props.dispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "images",
      payload: {
        ...props.images,
        pcm: [...files],
      },
    });
  };

  const [files, setFiles] = useState(props.images.pcm);
  const [imageToPreview, setImageToPreview] = useState({
    preview: "",
    fileName: "",
  });
  const [previewModal, setPreviewModal] = useState(false);
  const fileChange = (data) => {
    const fileData = data.target.files[0];
    const file = {
      lastModified: fileData.lastModified,
      name: fileData.name,
      size: fileData.size,
      type: fileData.type,
      webkitRelativePath: fileData.webkitRelativePath,
      preview: URL.createObjectURL(fileData),
    };
    setFiles((files) => [...files, file]);
  };

  const handleFiles = (event) => {
    if (event.actionItem.action === "preview") {
      hanldePreviewModal();
      setImageToPreview(() => ({
        preview: event.file.preview,
        fileName: event.file.name,
      }));
    }
  };

  const hanldePreviewModal = () => {
    setPreviewModal(!previewModal);
  };

  const hasRecommendations = false;

  // Check if recommendations exist
  const showComments = React.useMemo(() => {
    // First check if required objects exist
    if (
      !props.postmortemCurrentStatus ||
      !props.PreventiveAndCorrectiveMeasuresState
    ) {

      return false;
    }

    // Check if comments should be shown based on postmortem status
    const notInInitialState =
      props.postmortemCurrentStatus.currentState &&
      props.postmortemCurrentStatus.currentState !== "DRAFT";

    // Check if NEW comments exist
    const hasNewComments =
      props.PreventiveAndCorrectiveMeasuresState &&
      props.PreventiveAndCorrectiveMeasuresState.comments &&
      Array.isArray(props.PreventiveAndCorrectiveMeasuresState.comments.NEW) &&
      props.PreventiveAndCorrectiveMeasuresState.comments.NEW.length > 0;

    // Check for early state with DONE comments
    const inEarlyState =
      props.PreventiveAndCorrectiveMeasuresState &&
      props.PreventiveAndCorrectiveMeasuresState.curentState === "DRAFT";

    const hasDoneComments =
      props.PreventiveAndCorrectiveMeasuresState &&
      props.PreventiveAndCorrectiveMeasuresState.comments &&
      Array.isArray(props.PreventiveAndCorrectiveMeasuresState.comments.DONE) &&
      props.PreventiveAndCorrectiveMeasuresState.comments.DONE.length > 0;

    const hasReviewComments =
      props.PreventiveAndCorrectiveMeasuresState &&
      props.PreventiveAndCorrectiveMeasuresState.comments &&
      Array.isArray(
        props.PreventiveAndCorrectiveMeasuresState.comments.INPROGRESS
      ) &&
      props.PreventiveAndCorrectiveMeasuresState.comments.INPROGRESS.length > 0;

    // Return true if either condition is met
    if (notInInitialState) return true;

    return (
      hasNewComments || (inEarlyState && (hasDoneComments || hasReviewComments))
    );
  }, [
    props.postmortemCurrentStatus,
    props.PreventiveAndCorrectiveMeasuresState,
  ]);

  return (
    <>
      <Row
        style={{
          gap:
            props.postmortemCurrentStatus.currentState === "DRAFT"
              ? "40px"
              : "",
        }}
        className="gx-4 mt-2"
      >
        <Col
          xxl={12}
          className="pcm-content-wrapper scrollbar sixth-step"
          style={{}}
        >
          <div id="section-pcm" className="sre-section-card">
            <div className="sre-section-header">
              <span className="sre-section-header-title">Preventive And Corrective Measures</span>
              {(props.PreventiveAndCorrectiveMeasuresState?.jiraTickets?.length > 0 ||
                props.PreventiveAndCorrectiveMeasuresState?.pTasks?.length > 0) && (
                <span className="sre-section-complete-badge">✓ Complete</span>
              )}
              <McTooltip position="bottom-right" fit="small" width={340}>
                <McIcon slot="trigger" icon="info-circle" size="16" style={{ cursor: "pointer", color: "#fff" }} />
                <div style={{ fontSize: "12px", lineHeight: "1.6", padding: "4px 0" }}>
                  <strong>SRE Best Practices — Preventive & Corrective Measures</strong>
                  <ul style={{ margin: "6px 0 0", paddingLeft: "16px" }}>
                    <li>Every action must be <strong>SMART</strong>: Specific, Measurable, Achievable, Relevant, Time-bound</li>
                    <li>Create a Jira or PTask for every action — no untracked items</li>
                    <li>Each action needs a named owner and a concrete due date</li>
                    <li>Separate <em>corrective</em> (fix this incident) from <em>preventive</em> (stop recurrence)</li>
                    <li>At least one action should address the systemic root cause</li>
                  </ul>
                </div>
              </McTooltip>
              <span className="sre-section-header-badge" style={{ flex: 1 }}>
                List lessons learned, actions, backlog entries to prioritise
              </span>
              {props.aiInsight && (
                <button
                  className={`sre-section-header-action${aiOpen ? " sre-section-header-action--ai-active" : ""}`}
                  onClick={() => setAiOpen((v) => !v)}
                >
                  <McIcon icon="sparkle" size="12" />
                  AI Review
                  <McIcon icon={aiOpen ? "chevron-up" : "chevron-down"} size="12" />
                </button>
              )}
            </div>
          <div className={`sre-section-body${aiOpen && props.aiInsight ? " sre-section-body--with-ai" : ""}`}>
            <div className={aiOpen && props.aiInsight ? "sre-section-content" : undefined}>
          {/* Recommended Actions Section */}
          {hasRecommendations && (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "10px",
                }}
              >
                <Typography
                  variant="h3"
                  fontStyle="bold"
                  style={{
                    fontSize: "16px",
                  }}
                >
                  Recommended Actions
                </Typography>
                <div>
                  <Icon
                    onClick={() => setShowRecommnedations(!showRecommnedations)}
                    name={showRecommnedations ? "eye" : "eye-slash"}
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </div>

              {showRecommnedations && (
                <div className="recommended-actions-container">
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fill, minmax(240px, 1fr))",
                      gap: "15px",
                      marginBottom: "20px",
                    }}
                  >
                    {props.PreventiveAndCorrectiveMeasuresState.recommendedActions.map(
                      (action, index) => (
                        <div
                          key={index}
                          style={{
                            backgroundColor: "#B5E0F5",
                            padding: "15px",
                            borderRadius: "10px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "14px",
                              wordBreak: "break-word",
                            }}
                          >
                            {action.description}
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              )}
            </>
          )}

          <Box p={6}>
            <Group
              fit="medium"
              id="fruit"
              label="Please select the tracking method"
              name="fruit"
              onChange={handleRadioChange}
              options={[
                {
                  id: "Jira",
                  label: "Jira",
                  value: "Jira",
                },
                {
                  id: "PTask",
                  label: "PTask",
                  value: "PTask",
                },
              ]}
              orientation="horizontal"
              value={radioOption}
            />
          </Box>
          {radioOption != null &&
            (radioOption === "PTask" ? (
              <PTask
                contextState={
                  props.PreventiveAndCorrectiveMeasuresState &&
                  props.PreventiveAndCorrectiveMeasuresState
                }
                pTasks={
                  props.PreventiveAndCorrectiveMeasuresState.pTasks
                    ? props.PreventiveAndCorrectiveMeasuresState.pTasks
                    : []
                }
                dispatch={props.dispatch}
                images={props.images}
                imageFormData={props.imageFormData}
                incidentID={props.incidentID}
                currentStep={props.currentStep}
                lockedFields={props.lockedFields}
                changedFields={props.changedFields}
                onAutoSave={props.onAutoSave}
              />
            ) : (
              <Jira
                contextState={
                  props.PreventiveAndCorrectiveMeasuresState &&
                  props.PreventiveAndCorrectiveMeasuresState
                }
                jiraTickets={
                  props.PreventiveAndCorrectiveMeasuresState.jiraTickets
                    ? props.PreventiveAndCorrectiveMeasuresState.jiraTickets
                    : []
                }
                dispatch={props.dispatch}
                images={props.images}
                imageFormData={props.imageFormData}
                incidentID={props.incidentID}
                currentStep={props.currentStep}
                lockedFields={props.lockedFields}
                changedFields={props.changedFields}
                onAutoSave={props.onAutoSave}
              />
            ))}
            </div>{/* sre-section-content */}
            {aiOpen && props.aiInsight && (
              <div className="sre-section-ai-col">
                <AiSuggestionsInline insight={props.aiInsight} sectionName="Preventive & Corrective Measures" dim={props.aiDim} />
              </div>
            )}
          </div>{/* sre-section-body */}
          </div>{/* sre-section-card */}
        </Col>
        <div ref={divRef}></div>

        <PhotoUploadModal
          onSave={() => console.log("Save")}
          modalOpen={photoModal}
          handleModal={handlePhotoModalClick}
          handleModalClose={handlePhotoModalClose}
          files={files}
          handleFiles={handleFiles}
          fileChange={fileChange}
          hanldePreviewModal={hanldePreviewModal}
          imageToPreview={imageToPreview}
          previewModal={previewModal}
        />
      </Row>
    </>
  );
}

export default PreventiveAndCorrectiveMeasures;
